import scoreSetSettingsEvents from './scoreSetSettingsEvent';
import labels from "../sectionLabels";
import toolTips from "./models/sectionToolTips";
import verticalProviderDefaults from './models/verticalProviderDefaults';
import {topSet, withDescendants} from '../scoreHierarchy';
import {reduxStore} from "../../angularReactRedux/reduxStore";
import * as pulseApi from "../../../modules/pulse/api"
import scoresModule from "../scores-module";

const CONFIG_SORT_ORDER = Object.keys(topSet);

const buildAccountsBrandRestrictions = (restrictions, accounts) => {
  const data = {};
  restrictions.forEach((resp, i) => data[accounts[i].id] = resp.data.config.restrictions);
  return data;
};

scoresModule.factory('scoreSetActions', (
    userService,
    accountsService,
    configService,
    locationService,
    providerService,
    keywordService,
    scoreSettingsService,
    scoreResultsService
) => {
  // TODO - no need for a class. Just some functions, would reduce the need for all the "this" usages and initialization
  class ScoreSetActions {
    constructor(){
      this.createScoreConfig = this.createScoreConfig.bind(this);
      this.updateScoreConfig = this.updateScoreConfig.bind(this);
      this.store = reduxStore;
      this.userService = userService;
      this.accountsService = accountsService;
      this.configService = configService;
      this.locationService = locationService;
      this.providerService = providerService;
      this.keywordService = keywordService;
      this.scoreSettingsService = scoreSettingsService;
      this.scoreResultsService = scoreResultsService;

      this.onReloaded = this.onReloaded.bind(this);
    }

    initData(){

      this.accountsService.listAccounts().then(accountResp => {
        let allAccountConfigs = accountResp.accounts.map(acct => this.configService.getBrandConfigForAccount(acct.id));
        let request = [
          this.providerService.allProviders(false),
          this.scoreSettingsService.getScoreSets(),
          this.keywordService.listVerticals(),
          Promise.all(allAccountConfigs),
          locationService.locationsAndGroups()
        ];

        Promise.all(request)
          .then(([
                   providers,
                   scoreSets,
                   verticals,
                   accounts,
                   locationsAndGroups
                 ]) => {
            const brandRestrictions = buildAccountsBrandRestrictions(accounts, accountResp.accounts);

            this.onSuccess(scoreSetSettingsEvents.SCORE_INIT, {
              providers: this.providerService.providers,
              accounts: accountResp.accounts,
              scoreSets: this.sortScoreConfigs(scoreSets.scoreConfigs),
              scoreSetsDefaults: this.sortScoreConfigs(scoreSets.globalDefaults),
              verticals: verticals.verticals,
              brandRestrictions,
              labels,
              toolTips,
              verticalProviderDefaults,
              locations: [...locationsAndGroups.locations].map(location => {
                location.id = location.id.replace("legacy-", "");
                return location;
              })
            })});
      })

    }
    sortScoreConfigs(sets){
      let customerSets = [];
      let defaultsSets = [];
      sets.forEach(set => {
        this.sortScoreConfig(set.scoreConfig)
        set.scoreConfig.isDefault ? defaultsSets.push(set) : customerSets.push(set)
      });

      return [...customerSets, ...defaultsSets];
    }
    sortScoreConfig(config){
      const sortedComponents = [];
      CONFIG_SORT_ORDER.forEach(id => {
        const selected = config.components.find(component => component.id === id);
        let descendants = withDescendants(id, 2);
        descendants.splice(0,1);
        sortedComponents.push(this.sortComponentWithDescendants(selected, descendants))
      });
      config.components = sortedComponents;

      return config;
    }
    //for now only one level deep, perhaps move sorting server-side
    sortComponentWithDescendants(component, descendants){
      if(descendants && descendants.length){
        let sorted = component.components.filter(c => c.id.indexOf('provider') !== -1)
          .reduce((xs, x) => xs.concat([x]), []);
        descendants.forEach(id => sorted.push(component.components.find(c => c.id === id)));
        component.components = sorted;
      }
      return component;
    }

    createScoreConfig(scoreSet){
      this.store.dispatch({ type: scoreSetSettingsEvents.SCORE_SET_API_REQUEST });
      return this.scoreSettingsService
        .createScoreSet(scoreSet)
        .then(this.scoreSettingsService.getScoreSets)
        .then(this.onReloaded)
    }

    updateScoreConfig(scoreSet) {
      this.store.dispatch({ type: scoreSetSettingsEvents.SCORE_SET_API_REQUEST });
      this.store.dispatch({ type: scoreSetSettingsEvents.UPDATE_SCORE_SET, data: scoreSet });
      return this.scoreSettingsService
        .updateScoreSet(scoreSet)
        .then(this.scoreSettingsService.getScoreSets)
        .then(this.onReloaded)
    }

    deleteScoringConfig(scoreSet){
      this.store.dispatch({ type: scoreSetSettingsEvents.SCORE_SET_API_REQUEST });
      return this.scoreSettingsService
        .deleteScoreSet(scoreSet.scoreConfig._id.$oid)
        .then(this.scoreSettingsService.getScoreSets)
        .then((data) => { console.log('reload'); return data})
        .then(this.onReloaded)
    }

    onReloaded(resp) {
      return this.onSuccess(scoreSetSettingsEvents.RELOAD_SCORE_SETS,  this.sortScoreConfigs(resp.scoreConfigs));
    }
    onSuccess(type, data){
      this.store.dispatch({ type, data });
      return data;
    }
    onError(ex, onError){
      //TODO - get error from ex
      this.store.dispatch({
        type: scoreSetSettingsEvents.SCORE_SET_API_ERROR,
        data: ex
      });
      onError && onError(ex);
      return ex;
    }
    goNext(next){
      return (data) => {
        if(next && typeof next === 'function') return next(data);
        return data;
      }
    }

    fetchScores(scoreConfigId, verticalIds) {
      this.store.dispatch({ type: scoreSetSettingsEvents})
    }

  }

  return new ScoreSetActions()
})

